import { globalLayoutRoute } from "@routes";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

export const userProfileRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `me/profile`,
    component: lazyRouteComponent(() => import("./UserProfile"), "UserProfile"),
});
